// Redux Toolkit slice for categories

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IChemicalModel } from "../../data/ChemicalModel";
import { logOut } from "../actions/user";

type ICategoriesState = {
    show: boolean;
    compound?: IChemicalModel | null;
};

const initialState: ICategoriesState = {
    show: false,
    compound: null,
};

const categoriesSlice = createSlice({
    name: "categories",
    initialState,
    reducers: {
        openCategories(state, action: PayloadAction<IChemicalModel>) {
            state.show = true;
            state.compound = action.payload;
        },
        closeCategories(state) {
            state.show = false;
            state.compound = null;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(logOut.request, () => initialState);
    },
});

export const { openCategories, closeCategories } = categoriesSlice.actions;
export default categoriesSlice.reducer;
